
import { Component, Vue, Prop, Watch} from 'vue-property-decorator';

import InvestmentsFsSurvey from "./InvestmentsFSSurvey.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";

import PageBase from "../../PageBase.vue";

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

@Component({
    components:{
      InvestmentsFsSurvey,
      PageBase
    }
})
export default class InvestmentsFS extends Vue {
  
    @Prop({required: true})
    step!: stepInfoType

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void
    

    @Watch('investmentsData')
    investmentsDataChange(newVal) 
    {
        this.UpdateStepResultData({step:this.step, data: {investmentsFSSurvey: this.getInvestmentsResults()}})  
    }

    currentStep =0;
    currentPage =0;
    showTable = true;
    investmentsData = [];
    anyRowToBeEdited = null;
    editId = null;
 
    created() {
        if (this.step.result?.investmentsFSSurvey?.data) {
            this.investmentsData = this.step.result.investmentsFSSurvey.data;
        }
    }

    mounted(){        
        const progress = this.investmentsData?.length>0? 100 : 50;            
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
        Vue.nextTick(()=>{
            const el = document.getElementById('investments-fs-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public childComponentData(value) {
        this.showTable = value;
    }

    public populateSurveyData(investmentsValue) {
        const currentIndexValue = this.investmentsData?.length > 0 ? this.investmentsData[this.investmentsData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newInvestments = { ...investmentsValue, id };

        this.investmentsData = this.investmentsData? [...this.investmentsData, newInvestments]:[newInvestments];

        this.showTable = true; 
    }

    public deleteRow(rowToBeDeleted) {
        this.investmentsData = this.investmentsData.filter(data => {
            return data.id !== rowToBeDeleted;
        });
    }

    public editRow(editedRow) {
        this.investmentsData = this.investmentsData.map(data => {
            return data.id == this.editId ? editedRow : data;
        });
        this.showTable = true;
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();
    }

    public isDisableNext() {    
        if(this.investmentsData?.length > 0) return false;
        else return true;
    }    

    beforeDestroy() {
        const progress = this.investmentsData?.length>0? 100 : 50;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);
        this.UpdateStepResultData({step:this.step, data:{investmentsFSSurvey: this.getInvestmentsResults()}})       
    }
   
    public getInvestmentsResults(){
        const questionResults: {name:string; value: string[]; title:string; inputType:string}[] =[];
        if(this.investmentsData)
            for(const investments of this.investmentsData)
            {
                questionResults.push({name:'investmentsFSSurvey', value: this.getInvestmentsInfo(investments), title:'Investments '+investments.id +' Information', inputType:''})
            }

        return {data: this.investmentsData, questions:questionResults, pageName:'Investments', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getInvestmentsInfo(investments){        
        const resultString: string[] = [];
        resultString.push(Vue.filter('styleTitle')("Description: ")+investments.investmentsDescription);
        resultString.push(Vue.filter('styleTitle')("Value: ")+investments.investmentsValue);
        return resultString
    }

}
